import React, { FunctionComponent } from 'react';
import { Card, CardContent, Typography, makeStyles } from '@rbx/ui';
import { TSchemaItem } from './SchemasProvider';
import SchemaTable from './SchemaTable';

type useStylesProps = { indent: number };

export type TSchemaItemList = {
  listName: string;
  items: TSchemaItem[];
  indent: number;
};

const useStyles = makeStyles<useStylesProps>()((_, { indent }) => ({
  container: {
    marginTop: 24,
    marginLeft: indent * 8,
    paddingRight: 16,
    width: '100%',
    position: 'relative',
  },
  header: {
    marginTop: 8,
    marginRight: 8,
    marginLeft: 8,
    fontSize: 18,
    '& .inline-code': {
      fontSize: '0.95em',
    },
  },
}));

export type SchemaTableListProps = {
  header: string | React.ReactNode;
  refName: string;
  items: TSchemaItem[];
  indent: number;
};

const SchemaTableList: FunctionComponent<React.PropsWithChildren<SchemaTableListProps>> = ({
  refName,
  header,
  indent = 0,
  items,
}) => {
  const {
    classes: { container, header: headerStyle },
  } = useStyles({ indent });
  return (
    <div className={container}>
      <Card variant='filled'>
        <CardContent>
          <header>
            <Typography component='h4' className={headerStyle} color='primary' variant='h4'>
              {header}
            </Typography>
          </header>
          <SchemaTable refName={refName} properties={items} />
        </CardContent>
      </Card>
    </div>
  );
};

export default SchemaTableList;
